import { Link } from "react-router-dom";

// Ordered by how the work runs rather than by when each screen was built:
// what needs me today, then the customer's journey in - their requirement,
// the order, the society, the money - then what we have to sell, then who we
// buy it from. The old Product Management screen predates the catalogue and
// is kept under Other until it is retired.
const LeftMenu = () => {
  return (
    <>
      <div className="container-fluid">
        {/* sidebar: title*/}
        <div className="title-text d-flex align-items-center mb-4 mt-1">
          <a href="../admin/dashboard.html">
            <h4 className="sidebar-title mb-0 flex-grow-1">
              <span className="sm-txt">
                <img alt="" width="40px" />
              </span>
              <span>
                <img alt="" width="75px" style={{ paddingLeft: 10 }} />
              </span>
            </h4>
          </a>
        </div>
        {/* sidebar: menu list */}
        <div className="main-menu flex-grow-1">
          <ul className="menu-list">
            {/* <li class="divider py-2 lh-sm"><span class="small">MAIN</span><br> 
              <small class="text-muted">Unique dashboard designs </small>
          </li> */}
            <li>
              <Link className="m-link active" to="/dashboard">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M1 1h6v6H1V1zm8 0h6v4H9V1zM1 9h6v6H1V9zm8-2h6v8H9V7z"></path>
                </svg>
                <span className="ms-2">Today</span>
                <span className="highlight">Today</span>
              </Link>
              </li>
            <li className="divider py-2 lh-sm"><span className="small text-muted">Customers</span></li>
            <li>
              <Link className="m-link active" to="/requirements">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"></path>
                  <path className="fill-secondary" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4z"></path>
                </svg>
                <span className="ms-2">Requirements</span>
                <span className="highlight">Requirements</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/orders">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102z"></path>
                  <path className="fill-secondary" d="M5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"></path>
                </svg>
                <span className="ms-2">Orders</span>
                <span className="highlight">Orders</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/societies">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022ZM6 8.694 1 10.36V15h5V8.694ZM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15Z"></path>
                  <path className="fill-secondary" d="M2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-2 2h1v1H2v-1Zm2 0h1v1H4v-1Zm4-4h1v1H8V9Zm2 0h1v1h-1V9Zm-2 2h1v1H8v-1Zm2 0h1v1h-1v-1Zm2-2h1v1h-1V9Zm0 2h1v1h-1v-1ZM8 7h1v1H8V7Zm2 0h1v1h-1V7Zm2 0h1v1h-1V7ZM8 5h1v1H8V5Zm2 0h1v1h-1V5Zm2 0h1v1h-1V5Zm0-2h1v1h-1V3Z"></path>
                </svg>
                <span className="ms-2">Societies</span>
                <span className="highlight">Societies</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/organizations">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022ZM6 8.694 1 10.36V15h5V8.694ZM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15Z"></path>
                  <path className="fill-secondary" d="M2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-2 2h1v1H2v-1Zm2 0h1v1H4v-1Zm4-4h1v1H8V9Zm2 0h1v1h-1V9Zm-2 2h1v1H8v-1Zm2 0h1v1h-1v-1Zm2-2h1v1h-1V9Zm0 2h1v1h-1v-1ZM8 7h1v1H8V7Zm2 0h1v1h-1V7Zm2 0h1v1h-1V7ZM8 5h1v1H8V5Zm2 0h1v1h-1V5Zm2 0h1v1h-1V5Zm0-2h1v1h-1V3Z"></path>
                </svg>
                <span className="ms-2">On the portal</span>
                <span className="highlight">On the portal</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/receivables">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M1 3h14v3H1V3zm0 5h14v5H1V8zm2 2v1h4v-1H3z"></path>
                </svg>
                <span className="ms-2">Collection</span>
                <span className="highlight">Collection</span>
              </Link>
              </li>
            <li className="divider py-2 lh-sm"><span className="small text-muted">What we sell</span></li>
            <li>
              <Link className="m-link active" to="/catalogue/price-list">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M2 2h12v2H2V2zm0 4h12v2H2V6zm0 4h8v2H2v-2z"></path>
                  <path className="fill-secondary" d="M12 10h2v4h-2v-4z"></path>
                </svg>
                <span className="ms-2">Price list</span>
                <span className="highlight">Price list</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/catalogue/products">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M8 0a1 1 0 0 1 1 1v1.07A7.002 7.002 0 0 1 14.93 7H16a1 1 0 1 1 0 2h-1.07A7.002 7.002 0 0 1 9 14.93V16a1 1 0 1 1-2 0v-1.07A7.002 7.002 0 0 1 1.07 9H0a1 1 0 0 1 0-2h1.07A7.002 7.002 0 0 1 7 2.07V1a1 1 0 0 1 1-1z"></path>
                  <path className="fill-secondary" d="M8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"></path>
                </svg>
                <span className="ms-2">Catalogue</span>
                <span className="highlight">Catalogue</span>
              </Link>
              </li>
            <li className="divider py-2 lh-sm"><span className="small text-muted">Buying</span></li>
            <li>
              <Link className="m-link active" to="/vendor-inbox">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z"></path>
                  <path className="fill-secondary" d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.48 16 12.569 16c.502 0 .974-.055 1.353-.166a.5.5 0 0 0-.278-.96c-.32.09-.7.126-1.075.126-1.5 0-2.577-.7-2.577-2.24v-.212c0-1.51.987-2.556 2.526-2.556h.031c1.56 0 2.31.949 2.31 2.207v.21c0 .687-.223 1.093-.63 1.093-.284 0-.446-.201-.446-.526v-2.12a.5.5 0 0 0-.9-.3l-.076.1a1.7 1.7 0 0 0-1.187-.464c-1.077 0-1.826.86-1.826 2.078v.005c0 1.222.749 2.077 1.826 2.077.713 0 1.245-.371 1.503-.998v.012c.087.588.446.925.944.925Z"></path>
                </svg>
                <span className="ms-2">Vendor Inbox</span>
                <span className="highlight">Vendor Inbox</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/catalogue/field-rates">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M2 3h12v1.5H2V3zm0 4h12v1.5H2V7zm0 4h8v1.5H2V11z"></path>
                  <path className="fill-secondary" d="M12.5 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"></path>
                </svg>
                <span className="ms-2">Field rates</span>
                <span className="highlight">Field rates</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/catalogue/vendors">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                  <path className="fill-secondary" d="M12.5 4a.5.5 0 0 1 .5.5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 .5-.5z"></path>
                </svg>
                <span className="ms-2">Vendors</span>
                <span className="highlight">Vendors</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/catalogue/rate-freshness">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm.5 3v4.2l3 1.8-.5.9L7.5 8.8V4h1z"></path>
                </svg>
                <span className="ms-2">Cost freshness</span>
                <span className="highlight">Cost freshness</span>
              </Link>
              </li>
            <li>
              <Link className="m-link active" to="/catalogue/app-users">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M4 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 1v11h8V2H4z"></path>
                  <path className="fill-secondary" d="M7 13h2v1H7z"></path>
                </svg>
                <span className="ms-2">Rates app</span>
                <span className="highlight">Rates app</span>
              </Link>
              </li>
            <li className="divider py-2 lh-sm"><span className="small text-muted">Reports</span></li>
            <li>
              <Link className="m-link active" to="/reports">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M1 13h1.5v-4H1v4zm3.25 0h1.5V6h-1.5v7zm3.25 0H9V3H7.5v10zm3.25 0h1.5V8h-1.5v5zM14 13h1.5V5H14v8zM0 14.5h16V16H0v-1.5z"></path>
                </svg>
                <span className="ms-2">Projections</span>
                <span className="highlight">Projections</span>
              </Link>
              </li>
            <li className="divider py-2 lh-sm"><span className="small text-muted">Other</span></li>
            <li>
              <Link className="m-link active" to="/product">
                <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width={18}>
                  <path d="M2.95 0.4C3.04315 0.275804 3.16393 0.175001 3.30279 0.105573C3.44164 0.0361451 3.59475 0 3.75 0L12.25 0C12.4052 0 12.5584 0.0361451 12.6972 0.105573C12.8361 0.175001 12.9569 0.275804 13.05 0.4L15.9 4.53333C15.9649 4.61988 16 4.72515 16 4.83333V15C16 15.2652 15.8946 15.5196 15.7071 15.7071C15.5196 15.8946 15.2652 16 15 16H1C0.734783 16 0.48043 15.8946 0.292893 15.7071C0.105357 15.5196 0 15.2652 0 15V4.83333C0 4.72515 0.0350889 4.61988 0.1 4.53333L2.95 0.4ZM7.5 1H3.75L1.5 4.33333H7.5V1ZM8.5 1V4.33333H14.5L12.25 1H8.5ZM15 5.33333H1V15H15V5.33333Z" fill="black"></path>
                  <rect x="6" y="7.11108" width="4.44444" height="6.22222" fill="black"></rect>
                  <path className="fill-secondary" d="M6 7.11108H10.4444V13.3333H6V7.11108Z" fill="black"></path>
                </svg>
                <span className="ms-2">Products (legacy)</span>
                <span className="highlight">Products (legacy)</span>
              </Link>
              </li>
            {/* <li class="divider py-2 lh-sm"><span class="small">Pages</span></li> */}
          </ul>
        </div>
        {/* sidebar: footer link */}
      </div>
    </>
  );
};
export default LeftMenu;
